import { render, staticRenderFns } from "./pg_home.vue?vue&type=template&id=31a85ba6"
import script from "./pg_home.vue?vue&type=script&lang=js"
export * from "./pg_home.vue?vue&type=script&lang=js"
import style0 from "./pg_home.vue?vue&type=style&index=0&id=31a85ba6&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports